import type { ParentRegistrationData } from './validation';

/**
 * Counts unique parent groups by email (case-insensitive), matching backend
 * mergeBulkImportRowsByParent / countMergedParentGroups behavior.
 */
export function countParentGroupsFromCsvRows(
  rows: Array<ParentRegistrationData>,
): number {
  const seen = new Set<string>();
  for (const row of rows) {
    const raw = row['Parent Email']?.trim();
    if (!raw) continue;
    seen.add(raw.toLowerCase());
  }
  return seen.size;
}
